//#region src/Button/lib/getButtonOptionByFlags.ts
/**
* Утилитарная функция получения конфигурации кнопки по входящим параметрам
*/
function getButtonOptionByFlags(hasLeftIcon, hasRightIcon, hasIcon, hasLabel) {
	if ((hasRightIcon || hasLeftIcon) && !hasLabel || hasIcon) return "HasNoLabel";
	if (hasLeftIcon && hasLabel) return "HasLeftIcon";
	if (hasRightIcon && hasLabel) return "HasRightIcon";
	return "HasNoIcon";
}
//#endregion
export { getButtonOptionByFlags };

//# sourceMappingURL=getButtonOptionByFlags.js.map